export const menuConfig = [
  { name: 'DELETE', icon: 'Icn_Delete', action: 'del' },
  { name: 'RENAME', icon: 'Icn_Edit', action: 'edit' }
];

export const helpMenu = [
  { name: 'Чат', icon: 'Icn_Chat', action: 'chat' },
  { name: 'Что нового в системе', icon: 'Icn_Whats-new', action: 'new' },
  { name: 'База знаний', icon: 'Icn_Helplooqme', action: 'help' },
  { name: 'Блог', icon: 'Icn_Blog', action: 'blog' },
  { name: 'Отправить отзыв', icon: 'Icn_Feedback', action: 'feedback' }
];

export const downloadMenu = [
  { name: 'PDF', icon: 'Icn_PDF', action: 'pdf' },
  { name: 'HTML', icon: 'Icn_HTML', action: 'html' },
  // { name: 'ZIP', icon: 'Icn_ZIP', action: 'zim' },
  { name: 'XLS', icon: 'Icn_XLS', action: 'xls' },
  { name: 'DOCX', icon: 'Icn_DOCX', action: 'docx' }
];

export const userMenu = [
  { name: 'SETTING', icon: 'Icn_account', action: 'account' },
  { name: 'EXIT', icon: 'Icn_Exit', action: 'exit' }
];
